<template>
  <nav class="bg-white text-blue-600 shadow-lg">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <!-- Logo/Título -->
        <div class="flex-shrink-0 flex items-center">
          <router-link to="/invoice-tabs">
            <img class="w-15 h-12" src="/junkanlogo_transparent_v3.png" />
          </router-link>
          <span class="text-xl font-semibold ml-2">AP Invoices{{ userCompany ? ` - ${userCompany}` : '' }}</span>
        </div>

        <!-- Menú Dinámico -->
        <div v-if="!isAuthChecking" class="ml-4 flex items-center">
          <template v-if="!isAuthenticated">
            <router-link
              to="/login"
              class="px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
            >
              Login
            </router-link>
          </template>

          <template v-else>
            <!-- Navigation Links -->
            <div class="flex items-center space-x-4 mr-4">
              <router-link
                to="/owner/dashboard"
                v-if="canSeeAllData"
                class="px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors"
              >
                Dashboard
              </router-link>

              <router-link
                to="/admin/users"
                v-if="canManageUsers"
                class="px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors"
              >
                Users
              </router-link>
              
              <router-link
                to="/invoice-tabs"
                class="px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors"
              >
                Invoices
              </router-link>

            </div>

            <!-- User Dropdown -->
            <div class="relative">
              <button
                @click="toggleDropdown"
                class="flex items-center space-x-2 focus:outline-none"
              >
                <span class="font-medium">{{ userDisplayName }}</span>
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>

              <!-- Dropdown Menu -->
              <div
                v-show="isDropdownOpen"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
              >
                <div class="py-1" role="none">
                  <a
                    href="#"
                    @click.prevent="logout"
                    class="block px-4 py-2 text-sm hover:bg-gray-100 text-blue-600"
                  >
                    Log Out
                  </a>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </nav>
</template>
  
<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const isDropdownOpen = ref(false);

    const isAuthenticated = !!store.state.user;
    const currentUser = store.state.user;
    const isAuthChecking = store.state.authChecking;

    const userDisplayName = computed(() => {
      if (!currentUser) return "User";
      
      const firstName = currentUser.first_name || "";
      const lastName = currentUser.last_name || "";
      const fullName = `${firstName} ${lastName}`.trim();
      
      return fullName || currentUser.email || "User";
    });

    const userCompany = computed(() => {
      return store.getters.userCompany || null;
    });
    const userRole = computed(() => {
      return store.getters.userRole || 'user';
    });
    const canManageUsers = computed(() => {
      return store.getters.canManageUsers || false;
    });
    const canSeeAllData = computed(() => {
      return store.getters.canSeeAllData || false;
    });

    // Methods
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const logout = async () => {
      try {
        await store.dispatch("logOut");
        isDropdownOpen.value = false;
        router.push("/login");
      } catch (error) {
        console.error("Logout error:", error);
      }
    };

    return {
      isDropdownOpen,
      isAuthenticated,
      isAuthChecking,
      userDisplayName,
      userCompany,
      userRole,
      canManageUsers,
      canSeeAllData,
      toggleDropdown,
      logout,
      currentUser
    };
  },
};
</script>
